import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Include helper methods for API calls
import {
  getReportProject as getReportProjectApi,
} from "../../helpers/fakebackend_helper";


export const getReportProject = createAsyncThunk(
  "getReportProject",
  async (id) => {
    try {
      const response = await getReportProjectApi(id); // New API call to get a single client by ID
      return response;
    } catch (error) {
      toast.error("Failed to fetch client by ID", { autoClose: 3000 });
      throw error;
    }
  }
);

